import React              from 'react'
import AppLayout          from '@/Layouts/AppLayout'
import OrganizationLayout from '@/Layouts/OrganizationLayout'
import { TeamSettings }   from "@/Pages/Teams/TeamSettings";
import { Inertia }        from "@inertiajs/inertia";
import LayoutIcon         from "@/Components/LayoutIcon";
import { Teams as TeamsIcon } from "@/Icons";

export default function EditTeam({ team, users, errors }) {

  return (
    <TeamSettings team={team.data} users={users} errors={errors}/>
  )
}

EditTeam.layout = page => (
  <AppLayout title="Edit team">
    <OrganizationLayout
      header="Edit team"
      byline={page.props?.team?.data?.name || 'No team found'}
      backAction={{ label: 'Back', callback: () => Inertia.visit('/teams') }}
      icon={<LayoutIcon><TeamsIcon size={40} className="text-black"/></LayoutIcon>}
    >{page}</OrganizationLayout>
  </AppLayout>
)
